import type { JobSalary } from "@lossdog/job-watchlists";
import { useSignals } from "@preact/signals-react/runtime";
import { cx } from "class-variance-authority";

import { NumberUtils } from "@/util/number.utils";

interface Props {
  jobSalary: JobSalary | null;
}

export const JobSalaryLastPrice = ({ jobSalary }: Props) => {
  useSignals();
  if (!jobSalary) return null;
  return (
    <span
      className={cx(
        "text-right",
        jobSalary.salaryUp.value && "animate-salary-flash-up text-success-200",
        jobSalary.salaryDown.value && "animate-salary-flash-down text-danger-200",
      )}
    >
      {NumberUtils.formatAsUSCurrency(jobSalary.salary.value)}
    </span>
  );
};
